import react from "react";
import AboutUsSection from "../About-section";
import TeamSection from "../Team-section";
import MapSection from "../MapSection";
import FAQ from "../FAQ";
function AboutUs() {
  return (
    <>
      <AboutUsSection />
      <TeamSection />
      <MapSection />
      <FAQ />
    </>
  );
}
export default AboutUs;
